export default __webpack_public_path__ + "static/media/instagram-DarkBlue.8fbfa774.png";